import React from "react";
import styled from "styled-components";

// Styled components
const Container = styled.div`
  background: rgba(0, 0, 0, 0.5);
  border-bottom-left-radius: 8px;
  color: white;
  height: 400px;
  overflow: auto;
  padding: 10px;
  position: fixed;
  right: 0;
  top: 0;
  width: 400px;
  z-index: 1000;
`;

const CoordsDisplay = ({ coords /* = [{lat: 0, lng: 0}]*/ }) => {
  console.log(coords);
  return (
    <Container>
      {coords.now.map((shape, i) => {
        switch (shape.type) {
          case "circle": {
            return (
              <>
                <p>Shape {i + 1}: {"(circle)"}</p>
                <p>Center: Lat: {shape.snapshot.center.lat}, Lng: {shape.snapshot.center.lng}</p>
                <p>Radius (m): {shape.snapshot.radius}</p>
                <br />
              </>
            );
          }
          case "rectangle": {
            return (
              <>
                <p>Shape {i + 1}: {"(rectangle)"}</p>
                <p>North: {shape.snapshot.bounds.north}</p>
                <p>East: {shape.snapshot.bounds.east}</p>
                <p>South: {shape.snapshot.bounds.south}</p>
                <p>West: {shape.snapshot.bounds.west}</p>
                <br />
              </>
            );
          }
          case "polygon": {
            return (
              <>
                <p>Shape {i + 1}: {"(polygon)"}</p>
                {shape.snapshot.path.map((latLng) => {
                  return (
                  <p>Lat: {latLng.lat()}, Lng: {latLng.lng()}</p>
                )})}
                <br />
              </>
            );
          }
          default: {
            console.error(`type '${shape.type}' not recognized`);
            break;
          }
        }
      })}
    </Container>
  );
};

export default CoordsDisplay;
